<template>
  <div>
    <!-- <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/appraisal">{{ $t("appraisal") }}</router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">{{ $t("property types") }}</a>
        </li>
      </ul>
    </nav>

    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title">{{ $t("property types") }}</h1>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button is-success" @click="show_modal">
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ $t("new property type") }}</span>
          </button>
        </div>
      </div>
    </div> -->

    <!-- DataTable -->
    <generic-table
      :title="$t('property types')"
      resource_url="/appraisal/property-type/datatables"
      :columns="columns"
      :column_search="false"
      ref="generic_table"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="create_property_type"
        >
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add property type") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Modals -->
    <property-type-modal ref="property_type_modal" @success="refresh_table" />
    <property-type-detail-modal
      ref="property_type_detail_modal"
      @edit="edit_property_type"
    />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import PropertyTypeModal from "./property_type_modal/Index.vue";
import PropertyTypeDetailModal from "./property_type_detail_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  success_message,
  generate_error_message_text,
} from "@/utils";

export default {
  name: "PropertyTypeDataTable",
  components: {
    GenericTable,
    PropertyTypeModal,
    PropertyTypeDetailModal,
  },
  data() {
    return {
      table_url: "/appraisal/property-type/datatables",
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          data: (row) => {
            return `<div class="title is-6">${row.name || ""}</div>
                    <div class="subtitle is-7">${row.description || ""}</div>`;
          },
        },
        {
          title: this.$t("actions"),
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_property_type(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  v.delete_property_type(e.detail.uuid);
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  computed: {},
  methods: {
    show_modal(uuid = null) {
      this.$refs.property_type_modal.show_modal(uuid);
    },

    handle_button_click({ action, data }) {
      switch (action) {
        case "view":
          this.show_detail_modal(data.uuid);
          break;
        case "edit":
          this.edit_property_type(data.uuid);
          break;
        case "delete":
          this.delete_property_type(data.uuid);
          break;
      }
    },

    show_detail_modal(uuid) {
      this.$refs.property_type_detail_modal.show_modal(uuid);
    },

    edit_property_type(uuid) {
      this.$refs.property_type_modal.show_modal(uuid);
    },

    delete_property_type(uuid) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure delete property type"),
        v,
        () => {
          del("/appraisal/property-type", { uuid })
            .then(() => {
              success_message(v.$t("property type deleted successfully"));
              v.refresh_table();
            })
            .catch((error) => {
              v.$toast.error(generate_error_message_text(error));
            });
        }
      );
    },

    refresh_table() {
      this.$refs.generic_table.refresh();
    },
    create_property_type() {
      this.$refs.property_type_modal.show_modal();
    },
  },
  mounted() {
    this.refresh_table();
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 0;
}

.level {
  margin-bottom: 1.5rem;
}
</style>
